import { useEffect, useState } from "react";
import { IFileCustom } from "../../Atoms/Inputs/InputFile/useInputFile";
import { IDenunciaDTO, IDenunciaForm } from "../../../types/denuncia";
import { Denuncia } from "../../../services/Denuncia";
import { toast } from "react-toastify";
import { useContextSite } from "../../../context/Context";
import { useNavigate } from "react-router-dom";

export type FormStateNumber = 1 | 2 | 3;

export const useComplaint = () => {
  const [formState, setFormState] = useState<FormStateNumber>(1);
  const navigate = useNavigate();

  const { setIsLoad } = useContextSite();

  function handleSubmit(data: IDenunciaForm) {
    setIsLoad(true);
    Denuncia.post(data)
      .then(({ data }) => {
        navigate(`/denuncia?uuid=${data.uuid}`);
        setFormState(2);
      })
      .catch(
        ({
          response: {
            data: { mensagem },
          },
        }) => toast.error(mensagem)
      )
      .finally(() => {
        setIsLoad(false);
      });
  }

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return { formState, handleSubmit, setFormState };
};
